import type { VisualContentCatalog, VisualContentEntry } from "../config/catalog-schema";
import { parseVisualContentCatalog } from "./catalog-validation";

export class VisualCatalogRepository {
  private catalog: VisualContentCatalog | null = null;
  private readonly byId = new Map<string, VisualContentEntry>();

  async load(url = "./content/catalogs/visual-content-catalog.json"): Promise<VisualContentCatalog> {
    if (this.catalog) return this.catalog;
    const response = await fetch(url, { cache: "no-cache" });
    if (!response.ok) throw new Error(`Visual catalog request failed with ${response.status}`);
    const catalog = parseVisualContentCatalog(await response.json());
    this.catalog = catalog;
    catalog.entries.forEach((entry) => this.byId.set(entry.id, entry));
    return catalog;
  }

  getRequired(id: string): VisualContentEntry {
    const entry = this.byId.get(id);
    if (!entry) throw new Error(`Visual content is absent from the catalog: ${id}`);
    if (!entry.enabled) throw new Error(`Visual content is disabled: ${id}`);
    return entry;
  }
}
